import { createContext, useContext } from 'react';
import { WorkflowIssue } from 'src/utils/workflowValidation';

export interface WorkflowValidationValue {
  issues: WorkflowIssue[];
  showIssues: boolean;
}

export const WorkflowValidationContext = createContext<WorkflowValidationValue>({ issues: [], showIssues: false });

export const useNodeIssues = (nodeId: string): string[] => {
  const { issues, showIssues } = useContext(WorkflowValidationContext);
  if (!showIssues) return [];
  return issues.filter(issue => issue.nodeId === nodeId).map(issue => issue.message);
};
